import aiAxios from './aiAxios';
import { Message } from 'element-ui';
export function workUpload(data = {}) {
    return aiAxios('/work/anchor/upload', {
        method: 'post',
        data: data
    })
}


export function aiOralFindAll(data = {}) {
    return aiAxios('/aiOral/findAll', {
        method: 'post',
        data: data
    })
}

export function anchorVideoChatVoice(data = {}) { // 主播视频聊天语音接口
    return aiAxios('/anchor/video/chatVoice', { // 调用AI请求
        method: 'post', // POST请求
        data: data, // 请求数据
    })
}


export function anchorVideoChatVoiceRetalk(data = {}) { // 主播视频聊天语音接口
    return aiAxios('/anchor/video/videoRetalk', { // 调用AI请求
        method: 'post', // POST请求
        data: data, // 请求数据
    })
}

// 合成音频
export function anchorVideoChatVoiceGenerateVoice(data = {}) { // 主播视频聊天语音接口
    return aiAxios('/anchor/video/generateVoice', { // 调用AI请求
        method: 'post', // POST请求
        data: data, // 请求数据
    })
}

// 查询用户作品列表
export function pageAnchorUserWork(params = {}) {
    return aiAxios('/anchor/video/pageAnchorUserWork', {
        method: 'get',
        params: params
    })
}


// 一键配音查询配音员接口
export function anchorListVoiceModel() {
    return aiAxios('/anchor/video/listVoiceModel', {
        method: 'get',
    })
}

// 一键配音查询背景音乐接口
export function anchorListWorkTemplate() {
    return aiAxios('/anchor/video/listWorkTemplate', {
        method: 'get',
    })
}

// 配音接口
export function anchorVideoDubbing(data = {}) {
    return aiAxios('/anchor/video/dubbing', {
        method: 'post',
        data: data
    })
}


// 查询字典列表
export function anchorTextListDictInfoWorkType(data = {}) {
    return aiAxios('/anchor/text/listAllDictInfo', {
        method: 'get',
    })
}

export function streamChats(code,query) {
  const headers = new Headers();
  const token = localStorage.getItem("userMes") ? (eval('(' + localStorage.getItem("userMes") + ')').user_token) : "";
  
  if (token) {
    headers.append('paper_token', `${token}`);
  }
  
  const basePath = 'https://api.jasdm.cn/ai-platform';
  
  return fetch(`${basePath}${code}?message=${encodeURIComponent(query)}`, {
    method: 'GET',
    headers: headers
  });
}

// 语音播报
export function voiceChatVoice(data) {
    return aiAxios('/anchor/video/chatVoice',{
        method: 'post',
        data: data,
        timeout: 600000 // 增加超时时间为60秒
    })
}